<script lang="ts">
  export let className = "";
  export let fullWidth = false;
</script>

<div class={`w-full ${fullWidth ? "" : "max-w-[1600px]"} mx-auto px-4 py-6 sm:px-6 lg:px-8 ${className}`}>
  <slot />
</div>
